import { Navigate } from 'react-router';
import { useDestination } from 'util/useDestination';

export default function RedirectToAgentProfilePage() {
  const { toAgentProfile } = useDestination();
  return <Navigate to={toAgentProfile()} />;
}

export const Component = RedirectToAgentProfilePage;
